<section aria-labelledby="filter-heading" class="px-2 border-b border-primary-600 mb-4">
  <h2 id="filter-heading" class="sr-only">Filters</h2>

  <div class="bg-white pb-2">
    <div class="mx-auto flex items-center justify-between">
      <div class="relative inline-block text-left">
        <div>
          <button
            type="button"
            class="group inline-flex justify-center text-sm font-medium text-gray-700 hover:text-gray-900"
            id="menu-button"
            aria-expanded="false"
            aria-haspopup="true"
            #sortButton
            (click)="showSortDropdown(sortButton)"
            >
            {{ { key: 'sort' } | i18n }}
            <svg
              class="-mr-1 ml-1 h-5 w-5 flex-shrink-0 text-gray-400 group-hover:text-gray-500"
              viewBox="0 0 20 20"
              fill="currentColor"
              aria-hidden="true"
              >
              <path
                fill-rule="evenodd"
                d="M5.23 7.21a.75.75 0 011.06.02L10 11.168l3.71-3.938a.75.75 0 111.08 1.04l-4.25 4.5a.75.75 0 01-1.08 0l-4.25-4.5a.75.75 0 01.02-1.06z"
                clip-rule="evenodd"
                />
            </svg>
          </button>
        </div>
      </div>

      <div class="block">
        <div class="flow-root">
          <div class="-mx-4 flex items-center divide-x divide-gray-200">
            @if (!(showAllFilters | async)) {
              @for (row of firstFilters | async; track row._id) {
                <div class="px-4">
                  <ng-container [ngTemplateOutlet]="filterItem" [ngTemplateOutletContext]="{ row: row }"> </ng-container>
                </div>
              }
            }

            @if (((allFilters | async)?.length || 0) > 2 && !(showAllFilters | async)) {
              <div class="relative inline-block px-4 text-left">
                <button
                  type="button"
                  class="group inline-flex justify-center text-sm font-medium text-gray-700 hover:text-gray-900"
                  aria-expanded="false"
                  #filterButton
                  (click)="showAllFilters.next(!showAllFilters.value)"
                  >
                  <span>Alle Filter</span>
                </button>
              </div>
            }
            @if (showAllFilters | async) {
              <div class="relative inline-block px-4 text-left">
                <button
                  type="button"
                  class="group inline-flex justify-center text-sm font-medium text-gray-700 hover:text-gray-900"
                  aria-expanded="false"
                  #filterButton
                  (click)="showAllFilters.next(false)"
                  >
                  <span>Weniger Filter</span>
                </button>
              </div>
            }
          </div>
        </div>
      </div>
    </div>
    @if (showAllFilters | async) {
      <div class="bg-white pb-2 mt-4 max-w-full flex flex-row flex-wrap w-full">
        <div class="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-2 w-full">
          @for (row of allFilters | async; track row._id) {
            <div class="p-2 col-span-1 border">
              <ng-container [ngTemplateOutlet]="filterItem" [ngTemplateOutletContext]="{ row: row }"> </ng-container>
            </div>
          }
        </div>
      </div>
    }
  </div>
</section>

<ng-template #filterItem let-row="row">
  <button
    type="button"
    class="flex flex-row justify-between items-center text-sm font-medium text-gray-700 hover:text-gray-900 w-full overflow-hidden"
    aria-expanded="false"
    #filterButton
    (click)="showFilterDropdown(filterButton, row)"
    >
    <div class="flex flex-row items-center">
      <span>{{ row.designation | i18n }} </span>
      @if (algolia.observeAttributeFilterCount(row._id) | async; as filterCount) {
        <span
          class="bg-gray-100 text-gray-400 text-xs font-medium me-2 px-2.5 py-0.5 rounded-full ml-2"
          >{{ filterCount }}</span
          >
        }
      </div>

      <div>
        <svg
          class="-mr-1 ml-1 h-5 w-5 flex-shrink-0 text-gray-400 group-hover:text-gray-500"
          viewBox="0 0 20 20"
          fill="currentColor"
          aria-hidden="true"
          >
          <path
            fill-rule="evenodd"
            d="M5.23 7.21a.75.75 0 011.06.02L10 11.168l3.71-3.938a.75.75 0 111.08 1.04l-4.25 4.5a.75.75 0 01-1.08 0l-4.25-4.5a.75.75 0 01.02-1.06z"
            clip-rule="evenodd"
            />
        </svg>
      </div>
    </button>
  </ng-template>
